import { CoreState } from '../../../models';
import { removeHTMLTags } from '../../../utils';
import { CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreMutation } from '../core.interfaces';

export class SetInputQueryMutation implements CoreMutation {
  mutations = {
    [CORE_MUTATIONS_KEYS.setInputQuery]: (localState: CoreState, inputQuery: string) => {
      localState.inputQuery = removeHTMLTags(inputQuery);
    }
  };
}
